












import { Component, Vue } from 'vue-property-decorator';
import { eventBus } from '@/main';
import { APP_CONFIG } from '@/config/app-config';
@Component
export default class Auth extends Vue {

    get metaRoute() {
        return this.$route.meta;
    }

    private async created() {
        document.body.classList.add('signwrapper');
        eventBus.$emit(APP_CONFIG.eventBusAction.disableMenuLeft, true);
        eventBus.$emit(APP_CONFIG.eventBusAction.disableHeader, true);
        (window['getApp'] as any).$emit('SHOW_HIDE_MENU_LEFT', false);
    }

    private async destroyed() {
        document.body.classList.remove('signwrapper');
        eventBus.$emit(APP_CONFIG.eventBusAction.disableMenuLeft, false);
        eventBus.$emit(APP_CONFIG.eventBusAction.disableHeader, false);
    }
}
